import styled from 'styled-components'
import logo from '../../../../assets/svg/Navicons/Kita.png'
import { Link } from 'react-router-dom'

export const NavContainer = styled.div`
@import url('https://fonts.googleapis.com/css2?family=Inter&display=swap');

font-family: 'Inter', sans-serif;
height:100%;
display: grid;
place-items: center;
background-color: #16202b;
padding: 4.13em 3.5em;

 
 @media(max-width:612.33px){
    width: max-content;
   
 }

 @media(max-width:568px){
    width: max-content;
    padding: 5em 3.5em;
 }

 @media(max-width:548px){
    width: max-content;
    padding: 6.2em 3.5em;
 }

 @media(max-width:517px){
    width: max-content;
    padding: 7.8em 3.5em;
 }

 @media(max-width:489px){
    width: max-content;
    padding: 9.9em 3.5em;
 }

 @media(max-width:461px){
    width: max-content;
    padding: 11.3em 3.5em;
 }

 @media(max-width: 443.33px){
    padding: 12em 3.5em;
 }

 @media(max-width:431.33px){
    padding: 12.6em 3.5em;
 }
 @media(max-width:424.33px){
    padding: 12.6em 3.5em 13.6em 3.5em;
 }

 @media(max-width:415.33px){
    padding: 12.6em 3.5em 15em 3.5em;
 }

 @media(max-width:405.33px){
    padding: 12.6em 3.5em 16.6em 3.5em;
 }

 @media(max-width:395.33px){
    padding: 12.6em 3.5em 18em 3.5em;
 }

 @media(max-width:386.33px){
    padding: 12.6em 3.5em 19.6em 3.5em;
 }

 @media(max-width:377.33px){
    padding: 12.6em 3.5em 21em 3.5em;
 }

 @media(min-height:667px){
     padding: 12.6em 3.5em 24em 3.5em;
 }

//  @media(max-width:.33px){
//     padding: em 3.5em;
//  }

//  @media(max-width:.33px){
//     padding: em 3.5em;
//  }

//  @media(max-width:.33px){
//     padding: em 3.5em;
//  }

//  @media(max-width:.33px){
//     padding: em 3.5em;
//  }
`

export const OuterCircle = styled.div`
width: 32em;
height: 32em;
border-radius: 50%;
border: solid 1.5px #ccb6df;
display:grid;
place-items: center;
`
export const InnerCircle = styled.div`
width: 22.5em;
height: 22.5em;
border-radius: 50%;
display: grid;
place-items: center; 
position: absolute;
background-color: #0C2B41;
`
export const ContentCircle = styled.div`
width: 22.5em;
height: 22.5em;
border-radius: 50%;
display: grid;
grid-template-rows: 1.2fr 2fr;
place-items: center;
position: absolute;
background-color: #236B95;
opacity: 0;
transition: 450ms;

div{
    position: absolute;
    display: grid;
    place-items: center;
    opacity: 0;
}

h4{
    background-color: #09A896;
    width: 180px;
    height: 50px;
    border-radius: 8px;
    place-content: center;
    display: grid;
    align-self: end;
    margin-bottom: 7px;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #FFFFFF;
    text-shadow: 0 0.2em black; 

}

p{
    position: relative;
    font-weight: 500;
    font-size: 17px;
    line-height: 24px;
    color: white;
    align-self: start;
    text-align: center;
    padding: 0 20px;
    margin-top: 0.187px;
}
`

export const Logo = styled.div`
display: grid;
place-content: center;
position: absolute;

background-color: #0c2b41;
img{
   object-fit: cover;
    width:9.375em;
    height:9.375em;
}
`
export const StyledIcons = styled.div`
position: absolute;
display: contents;
a:nth-child(10){
   transform: translate( -9.94em, -12.44em );
}
a:nth-child(9){
    transform: translate( -15.4em, -4.4em );

}
a:nth-child(8){
    transform: translate( -15.4em, 4.8em );
}
a:nth-child(7){
    transform: translate( -9.94em, 12.44em );

}
a:nth-child(6){
    transform: translate( 0em, 16.04em );
   
}
a:nth-child(5){
    transform: translate( 9.94em, 12.44em );
   
}
a:nth-child(4){
     transform: translate( 15.4em, 4.8em );
}
a:nth-child(3){
    transform: translate( 15.4em, -4.4em );
}
a:nth-child(2){
    transform: translate( 9.94em, -12.44em );

}
a:nth-child(1){
    transform: translate( 0em, -16.04em );
} 

`
export const NavLink = styled(Link)`
    position:absolute;
    display:grid;
    border-radius: 50%;
    background-color: #16202b;
    text-decoration: none;
    width:5.6rem;
    height:5.6rem;
    transition:300ms;

    &:hover{
        background: linear-gradient(228.96deg, #FFFFFF -18.08%, #FFFFFF 122.67%);
        box-shadow: 0 0 7em 0 white;
        /* filter: blur(100px); */
        width: 8.2em;
        height: 8.2em;
        svg{
            /* background: linear-gradient(228.96deg, rgba(9, 166, 255, 0.5) -18.08%, rgba(83, 224, 255, 0.5) 122.67%); */
            transform: scale(1.6);
            padding: 0.2em;
           
        }
    }

    svg{
        place-self: center;
        transition: 300ms;
    }
`

export const LogoImg = () => (
    <img src={logo} alt = ''/>
)